module.exports = __webpack_public_path__ + "static/media/new image.38740e8e.png";